import * as THREE from 'three';
import ClipperLib from 'clipper-lib';
import profiles from '../scene/fixed-window-profiles.json';
import { windowOutline, insetOutline, fixedGlassInset } from './windowShapes';

const unit = ([x, y]) => { const length = Math.hypot(x, y); return [x / length, y / length]; };
const cleanedSection = points => ClipperLib.Clipper.CleanPolygon(points.map(([X, Y]) => ({ X, Y })), .12).map(p => [p.X, p.Y]);

// Sweep source section contours (including hollow chambers) around a convex
// visual outline. This is a forming concept, not a verified curved extrusion.
function sweepSection(rings, outline, depth) {
  const shifts = outline.map(([x, y], i) => {
    const p = outline[(i + outline.length - 1) % outline.length], n = outline[(i + 1) % outline.length];
    const a = unit([-(y - p[1]), x - p[0]]), b = unit([-(n[1] - y), n[0] - x]);
    const denominator = 1 + a[0] * b[0] + a[1] * b[1];
    return [(a[0] + b[0]) / denominator, (a[1] + b[1]) / denominator];
  });
  const positions = [], indices = [];
  rings.forEach(raw => {
    const ring = cleanedSection(raw); if (ring.length < 3) return;
    const start = positions.length / 3;
    outline.forEach(([x, y], i) => ring.forEach(([z, inset]) => positions.push(x + shifts[i][0] * inset / 1000, y + shifts[i][1] * inset / 1000, z / 1000 - depth / 2)));
    for (let i = 0; i < outline.length; i++) for (let j = 0; j < ring.length; j++) {
      const a = start + i * ring.length + j, b = start + ((i + 1) % outline.length) * ring.length + j;
      const c = start + ((i + 1) % outline.length) * ring.length + (j + 1) % ring.length, d = start + i * ring.length + (j + 1) % ring.length;
      indices.push(a, b, c, a, c, d);
    }
  });
  const geometry = new THREE.BufferGeometry(); geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3)); geometry.setIndex(indices); geometry.computeVertexNormals();
  return geometry;
}

export function makeShapedFixedWindow(product, materials, frame, shape) {
  const data = profiles[product.id], group = new THREE.Group(), outline = windowOutline(shape, product.width, product.height);
  const roles = { frame, thermal: materials.thermal, gasket: materials.gasket };
  data.components.forEach(component => {
    const material = roles[component.role] || frame; material.side = THREE.DoubleSide;
    component.shapes.forEach(section => {
      const mesh = new THREE.Mesh(sweepSection([section.outer, ...(section.holes || [])], outline, data.depth_mm / 1000), material);
      mesh.castShadow = true; mesh.receiveShadow = true; group.add(mesh);
    });
  });
  const inner = insetOutline(outline, fixedGlassInset(product.id));
  const pane = new THREE.Shape(inner.map(([x, y]) => new THREE.Vector2(x, y)));
  const glass = new THREE.Mesh(new THREE.ExtrudeGeometry(pane, { depth: .028, bevelEnabled: false, steps: 1 }), materials.glass);
  glass.position.z = -.014; glass.name = 'shaped-fixed-glazing'; group.add(glass);
  group.userData = { sourceProfileDepth: data.depth_mm, fixedWindow: true, customShape: shape };
  return { group, frame };
}